import { css } from 'styled-components'

export const wrapperStyle = css`
	display: flex;
	align-items: center;
	justify-content: right;
	&.fullWidthWrapper {
		width: 100%;
	}
	&.fullWidthWrapper form {
		width: calc(100% - 100px);
	}
	&.normalWrapper {
		width: unset;
		max-width: 200px;
		@media screen and (min-width: 1300px) and (max-width: 1380px) {
			max-width: 100px;
		}
		@media screen and (min-width: 1380px) and (max-width: 1470px) {
			max-width: 120px;
		}
		&.search-input-anonymous {
			width: 250px;
			max-width: 250px;
		}
		@media (max-width: 1140px) {
			max-width: 120px;
			&.search-input-anonymous {
				width: 250px;
				max-width: 250px;
			}
		}
	}
	.form-global-search {
		display: flex;
		align-items: center;
	}
`
